export default "__VITE_ASSET__KAEP8BRh__"